export default {
	props: {
		type: {
			type: String,
			default: 'default'
		},
		size: {
			type: String,
			default: 'sm'
		},
		disabled: {
			type: Boolean
		},
		icon: {
			type: Boolean
		}
	},
	computed: {
		classes() {
			return [
				`btn-${this.size}`,
				`btn-${this.type}`,
				{
					'btn-icon': this.icon
				}
			]
		}
	},
	methods: {
		onClick() {
			this.$emit('click')
		}
	}
}
